import { Badge } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

export const Wrapper = styled("div")(() => ({
  height: "100%",
}));

export const MandatoryBadge = styled(Badge)(() => ({
  backgroundColor: "#FEF3F2",
  color: "#D92D20",
  padding: "4px 8px",
  borderRadius: 4,
}));

export const ButtonText = styled("span")(() => ({
  whiteSpace: "nowrap",
}));

export const CardsWrapper = styled("div")(() => ({
  padding: "32px 8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 24,
}));

const styles = makeStyles(() => ({
  buttonIcon: {
    cursor: "pointer",
  },
  buttonInviteUser: {
    width: 132,
  },
  accordionDetailsWrapper: {
    flexDirection: "column",
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    "& > label": {
      marginBottom: 0,
      marginRight: 8,
    },
  },
}));

export default styles;
